import React from 'react'
import { Select } from '@surecompanies/core_components'
import dayjs from 'dayjs'
import { TIMEZONE_PST } from 'helpers/datetime'

export type TimezoneOption = 'local' | typeof TIMEZONE_PST

const LOCAL_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone
const LOCAL_LABEL = `Local (${LOCAL_TZ} — UTC${dayjs().format('Z')})`

const OPTIONS: { value: TimezoneOption; label: string }[] = [
  { value: 'local', label: LOCAL_LABEL },
  { value: TIMEZONE_PST, label: 'America/Los_Angeles (PT)' },
]

interface TimezoneSelectProps {
  value: TimezoneOption
  onChange: (tz: TimezoneOption) => void
  style?: React.CSSProperties
}

export function TimezoneSelect({
  value,
  onChange,
  style,
}: TimezoneSelectProps) {
  return (
    <Select<TimezoneOption>
      value={value}
      onChange={onChange}
      style={{ minWidth: 260, ...style }}
      options={OPTIONS}
      size="small"
    />
  )
}
